
import { defineComponent } from "vue";
import WebWidget from "./components/WebWidget.vue";

export default defineComponent({
  name: "App",
  components: {
    WebWidget,
  },
  props: {
    mode: {
      type: String,
      required: false,
      default: "full", // mini, full
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    contactTitle: {
      type: String,
      required: false,
      default: "",
    },
    filterButton: {
      type: String,
      required: false,
      default: "Sprawdź",
    },
    resultButton: {
      type: String,
      required: false,
      default: "Umów się",
    },
    contactFormButton: {
      type: String,
      required: false,
      default: "Wyślij",
    },
    campaignId: {
      type: String,
      required: false,
      default: "default",
    },
  },
});
